//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React, { useState } from 'react';
import styled from 'styled-components';

import { PrimaryLinkButton } from '@components/atoms/button/Button';
import Icon from '@components/atoms/icon/Icon';
import { BodyText } from '@components/atoms/text/Text';
import { UiaProductTrackingIds } from '@uia/products/constants/UiaProductConstants';
import { useGetPublishersForCreatorQuery } from '@uia/products/hooks/useGetPublishersForCreatorQuery';
import { useGetTaggedProductsStatsQuery } from '@uia/products/hooks/useGetTaggedProductsStatsQuery';
import { SkuLimitDialog } from '@uia/products/sku-limit/SkuLimitDialog';
import { isDefined } from '@utils/filterPredicates';
import { pluralize } from '@utils/stringUtils';

export const SkuLimit = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  //TODO: PD-262917 - UIA Products, React Port, Handle SkuLimit component loading and error states
  const { data: publishers } = useGetPublishersForCreatorQuery();
  const publisher = publishers?.publisherClients[0];

  //TODO: PD-262917 - UIA Products, React Port, Handle SkuLimit component loading and error states
  const { data: taggedProductsResponse } = useGetTaggedProductsStatsQuery(
    publisher?.id,
  );
  const { taggedProducts } = taggedProductsResponse ?? {};
  const skuLimit = publisher?.creatorBrandSkuLimit;

  if (!isDefined(skuLimit)) {
    return null;
  }

  return (
    <div>
      {(taggedProducts?.length ?? 0) > skuLimit ? (
        <IconWrapper>
          <Icon name='alarm' /> You've reached your TCIN limit
        </IconWrapper>
      ) : (
        <BodyText>
          You have up to {pluralize(skuLimit, 'TCIN')} in contract
        </BodyText>
      )}
      <PrimaryLinkButton
        onClick={() => setIsModalOpen(true)}
        trackingId={UiaProductTrackingIds.OPEN_SKU_LIMIT_MODAL_BUTTON}
      >
        View TCIN Summary
      </PrimaryLinkButton>

      {isDefined(publisher) && (
        <SkuLimitDialog
          isModalOpen={isModalOpen}
          publisher={publisher}
          setIsModalOpen={setIsModalOpen}
          skuLimit={skuLimit}
          taggedProducts={taggedProducts ?? []}
        />
      )}
    </div>
  );
};

const IconWrapper = styled.div(
  ({ theme }) => `
    align-items: center;
    display: flex;
    gap: ${theme.spacings[1]};
  `,
);
